<template>
  <div class="segmented-progress-container">
    <div class="segmented-progress-bar" :style="{ height: height + 'px' }">
      <div
        v-for="(segment, index) in segments"
        :key="index"
        class="progress-segment"
        :style="getSegmentStyle(segment, index)"
      >
        <div
          class="progress-segment-fill"
          :style="getSegmentFillStyle(segment)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "segmented-progress-bar",
  props: {
    height: {
      type: Number,
      default: 8,
    },
    primaryColor: {
      type: String,
      default: "#4CAF50",
    },
    totalSegments: {
      type: Number,
      required: true,
      validator: (value) => value > 0,
    },
    value: {
      type: Number,
      required: true,
      validator: (value) => value >= 0,
    },
  },
  computed: {
    segments() {
      return Array.from({ length: this.totalSegments }, (_, i) => ({
        index: i,
        start: i,
        end: i + 1,
      }));
    },
    secondaryColor() {
      // Use primary color with 0.3 opacity for background
      const hex = this.primaryColor.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, 0.3)`;
    },
  },
  methods: {
    getSegmentStyle(segment, index) {
      const isFirst = index === 0;
      const isLast = index === this.segments.length - 1;
      return {
        width: `${100 / this.totalSegments}%`,
        backgroundColor: this.secondaryColor,
        borderTopLeftRadius: isFirst ? "4px" : "0",
        borderBottomLeftRadius: isFirst ? "4px" : "0",
        borderTopRightRadius: isLast ? "4px" : "0",
        borderBottomRightRadius: isLast ? "4px" : "0",
      };
    },
    getSegmentFillStyle(segment) {
      let fillPercentage = 0;

      if (this.value >= segment.end) {
        // Segment is fully filled
        fillPercentage = 100;
      } else if (this.value > segment.start) {
        // Segment is partially filled
        fillPercentage =
          ((this.value - segment.start) / (segment.end - segment.start)) * 100;
      }
      // else: segment is not filled (0%)

      return {
        width: `${fillPercentage}%`,
        backgroundColor: this.primaryColor,
      };
    },
  },
};
</script>

<style scoped>
.segmented-progress-container {
  width: 100%;
}

.segmented-progress-bar {
  display: flex;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  gap: 3px;
  background-color: transparent;
  padding: 0;
}

.progress-segment {
  height: 100%;
  position: relative;
  overflow: hidden;
}

.progress-segment-fill {
  height: 100%;
  transition: width 0.3s ease;
}
</style>
